module.exports = __webpack_public_path__ + "img/charm_2.05c5e9ec.svg";